/*
  widget actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\dashboard\saga.js
*/
const actions = {
  WIDGET_UPDATE_SUCCESS: 'WIDGET_UPDATE_SUCCESS',
  WIDGET_UPDATE: 'WIDGET_UPDATE',

  //rest of user editor options
  apiWidgetsUpdate: (headerKeys, contentKeys) => ({
    type: actions.WIDGET_UPDATE,
    headerKeys,
    contentKeys,
  }),
};
export default actions;
